<template>
  <v-row class="h-100" no-gutters>
    <v-col cols="9">
      <v-container fluid>
        <StepperRepair
          v-if="
            currentRepairFile == null ||
            currentRepairFile.folder_type === FolderTypeConstant.REPAIR_FOLDER
          "
          @change-step="handleStepChange"
          @change-highest-step="handleHighestStepChange"
          :currentStep="currentStep"
          :highestStepReached="highestStepReached"
          :currentRepairFile="currentRepairFile"
        />

        <StepperProspect
          v-if="
            currentRepairFile != null &&
            currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER
          "
          @change-step="handleStepChange"
          @change-highest-step="handleHighestStepChange"
          :currentStep="currentStep"
          :highestStepReached="highestStepReached"
          :currentRepairFile="currentRepairFile"
        />

        <!--COMMON STEPPER-->
        <StepProduct
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="currentStep === 1 && getLoadingData"
        />
        <StepGenericBreakdown
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            currentRepairFile.product_folder_workflow === FolderWorkflowTypeConstant.GENERIC &&
            currentStep === 2 &&
            getLoadingData
          "
          ref="stepBreakdown"
        />
        <StepBreakdown
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            currentRepairFile.product_folder_workflow !== FolderWorkflowTypeConstant.GENERIC &&
            currentStep === 2 &&
            getLoadingData
          "
          ref="stepBreakdown"
        />
        <StepGuarantee
          @change-step="handleStepChange"
          @refresh-repair-file="handleRefreshRepairFile"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="currentRepairFile && currentStep === 3 && getLoadingData"
          ref="stepGuarantee"
        />
        <StepGenericPricing
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            currentRepairFile.product_folder_workflow === FolderWorkflowTypeConstant.GENERIC &&
            currentStep === 4 &&
            getLoadingData
          "
        />
        <StepPricing
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            currentRepairFile.product_folder_workflow !== FolderWorkflowTypeConstant.GENERIC &&
            currentStep === 4 &&
            getLoadingData
          "
          ref="stepPricing"
        />

        <!--REPAIR STEPPER-->
        <StepCreateRepairFolder
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :current-repair-file-props="currentRepairFile"
          v-if="
            currentStep === 5 &&
            currentRepairFile.folder_type === FolderTypeConstant.REPAIR_FOLDER &&
            getLoadingData
          "
          ref="stepCreateRepairFolder"
        />

        <!--COMMON STEP 5 FOR PROSPECT / 6 FOR REPAIR STEP-->
        <StepStoreInternalInformation
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            ((currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER &&
              currentStep === 5) ||
              (currentRepairFile.folder_type === FolderTypeConstant.REPAIR_FOLDER &&
                currentStep === 6)) &&
            getLoadingData
          "
          ref="stepStoreInternalInformation"
        />

        <!--PROSPECT STEPPER-->
        <StepCreateProspectFolder
          @change-step="handleStepChange"
          @refresh-repair-file="handleRefreshRepairFile"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="
            currentRepairFile &&
            currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER &&
            currentStep === 6 &&
            getLoadingData
          "
          ref="stepCreateProspectFolder"
        />

        <!--COMMON STEPPER-->
        <StepTransporter
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          v-if="currentRepairFile && currentStep === 7 && getLoadingData"
          ref="stepTransporterFolder"
        />
      </v-container>
    </v-col>
    <v-col class="info-col h-100" cols="3">
      <v-container class="custom-container">
        <div>
          <div v-if="recapSteps.includes(3)">
            <h1 class="repair-file-number text-center">
              N°{{ currentRepairFile?.internal_command_number }}
            </h1>
          </div>

          <div v-if="!recapSteps.includes(3)" class="line my-6" />

          <div v-if="recapSteps.length === 0" class="step-one-scroll-indicator">
            <img
              alt="scroll indicator"
              class="ml-2 white-icon"
              src="@/assets/icons/stepper/keyboard_double_arrow_down.svg"
            />
          </div>

          <div v-if="recapSteps.includes(1)">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="title mb-1">{{ $t('REPAIR_FILE_RECAP.STEP_ONE.TITLE') }}</div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">
                    {{ $t('REPAIR_FILE_RECAP.STEP_ONE.MANUFACTURER') }}
                  </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.manufacturer_name }}</div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_ONE.CATEGORY') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.category_name }}</div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">
                    {{ $t('REPAIR_FILE_RECAP.STEP_ONE.SUB_CATEGORY') }}
                  </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.sub_category_name }}</div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_ONE.PRODUCT') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.product_name }}</div>
                </v-col>
              </v-row>
            </v-card>

            <p
              v-if="
                currentRepairFile.product_folder_workflow === FolderWorkflowTypeConstant.POWER_TOOLS
              "
              class="mb-1 mt-6 d-flex justify-center content-text"
            >
              {{ $t('REPAIR_FILE_RECAP.STEP_ONE.QUESTION') }}
            </p>
            <p
              v-if="
                currentRepairFile.product_folder_workflow === FolderWorkflowTypeConstant.GENERIC
              "
              class="mb-1 mt-6 d-flex justify-center content-text"
            >
              {{ $t('REPAIR_FILE_RECAP.STEP_ONE.GENERIC_QUESTION') }}
            </p>
          </div>

          <div v-if="recapSteps.includes(2)">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="title mb-1">{{ $t('REPAIR_FILE_RECAP.STEP_TWO.TITLE') }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_TWO.BREAKDOWN') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.breakdown_description }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_TWO.TYPE') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ formattedTypeList }}</div>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div v-if="recapSteps.includes(3)">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="title mb-1">{{ $t('REPAIR_FILE_RECAP.STEP_THREE.TITLE') }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">
                    {{ $t('REPAIR_FILE_RECAP.STEP_THREE.GUARANTEE.TITLE') }}
                  </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card" v-if="isInGuarantee()">
                    {{ $t('REPAIR_FILE_RECAP.STEP_THREE.GUARANTEE.UNDER_GUARANTEE') }}
                  </div>
                  <div class="content-card" v-else>
                    {{ $t('REPAIR_FILE_RECAP.STEP_THREE.GUARANTEE.OUT_GUARANTEE') }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div v-if="recapSteps.includes(4) && !isInGuarantee()">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="title">{{ $t('REPAIR_FILE_RECAP.STEP_FOUR.TITLE') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div
                    class="sub-title"
                    v-if="currentRepairFile?.initial_pricing_type === 'PACKAGE'"
                  >
                    {{
                      $t('REPAIR_FILE_RECAP.STEP_FOUR.PACKAGE') +
                      ' ' +
                      (currentRepairFile?.initial_package_total_repair_cost).toFixed(2) +
                      '€'
                    }}
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">
                    {{ $t('REPAIR_FILE_RECAP.STEP_FOUR.CUSTOMER_CODE') }}
                  </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card" v-if="currentRepairFile?.initial_customer_code">
                    {{ 'n°' + currentRepairFile?.initial_customer_code }}
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <template v-if="currentRepairFile?.initial_pricing_type === 'PACKAGE'">
                  <v-col cols="auto">
                    <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_FOUR.PACKAGE') }}</div>
                  </v-col>
                  <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                    <div class="content-card">
                      {{ 'n°' + currentRepairFile?.package_network_code }}
                    </div>
                  </v-col>
                </template>
                <template v-else>
                  <v-col cols="auto">
                    <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_FOUR.ESTIMATE') }}</div>
                  </v-col>
                  <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                    <div class="content-card">
                      {{ $t('REPAIR_FILE_RECAP.STEP_FOUR.ASK_ESTIMATE') }}
                    </div>
                  </v-col>
                </template>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_FOUR.DELAY') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div
                    class="content-card"
                    v-if="currentRepairFile?.initial_pricing_type === 'PACKAGE'"
                  >
                    {{
                      currentRepairFile?.product_repair_time +
                      ' ' +
                      $t('REPAIR_FILE_RECAP.STEP_FOUR.DAYS')
                    }}
                  </div>
                  <div class="content-card" v-else>
                    {{ 28 + ' ' + $t('REPAIR_FILE_RECAP.STEP_FOUR.DAYS') }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div v-if="recapSteps.includes(5)">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="title">{{ $t('REPAIR_FILE_RECAP.STEP_FIVE.TITLE') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="sub-title">{{ currentRepairFile?.company }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_FIVE.NAME') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.lastname }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">{{ $t('REPAIR_FILE_RECAP.STEP_FIVE.CONTACT') }}</div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="content-card">{{ currentRepairFile?.phone_number }}</div>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div v-if="recapSteps.includes(6)">
            <v-card class="rounded-xl mt-6 d-flex-column" :border="false" :elevation="0">
              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="title">{{ $t('REPAIR_FILE_RECAP.STEP_SIX.TITLE') }}</div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-1">
                <v-col cols="auto">
                  <div class="content-card">
                    {{ $t('REPAIR_FILE_RECAP.STEP_SIX.INTERNAL_COMMAND_NUMBER') }}
                  </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-grow-1 justify-end">
                  <div class="sub-title">{{ currentRepairFile?.internal_command_number }}</div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </div>

        <div>
          <v-btn class="my-6 pl-15 pr-15 leave-button" variant="outlined" @click="leave()">
            <img
              alt="cross-icon"
              class="cross-white-svg"
              src="@/assets/icons/file/arrow-left-circle.svg"
            />
            {{ $t('COMMON.BUTTON.LEAVE') }}
          </v-btn>
        </div>
      </v-container>
    </v-col>
  </v-row>

  <LeaveModal ref="leaveModal" />
  <LeaveStepperModal ref="leaveStepperModal" />
</template>

<script>
import RepairFileService from '@/services/RepairFileService'
import StepProduct from '@/views/restricted/repair-file-module/folder-setup/steps/StepProductPage.vue'
import StepBreakdown from '@/views/restricted/repair-file-module/folder-setup/steps/StepBreakdownPage.vue'
import StepGenericBreakdown from '@/views/restricted/repair-file-module/folder-setup/steps/StepGenericBreakdownPage.vue'
import StepGuarantee from '@/views/restricted/repair-file-module/folder-setup/steps/StepGuaranteePage.vue'
import StepGenericPricing from '@/views/restricted/repair-file-module/folder-setup/steps/StepGenericPricingPage.vue'
import StepPricing from '@/views/restricted/repair-file-module/folder-setup/steps/StepPricingPage.vue'
import StepCreateRepairFolder from '@/views/restricted/repair-file-module/folder-setup/steps/StepCreateRepairFolderPage.vue'
import StepStoreInternalInformation from '@/views/restricted/repair-file-module/folder-setup/steps/StepStoreInternalInformationPage.vue'
import StepCreateProspectFolder from '@/views/restricted/repair-file-module/folder-setup/steps/prospect-folder/StepCreateProspectFolder.vue'
import StepTransporter from '@/views/restricted/repair-file-module/folder-setup/steps/StepTransporterPage.vue'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import FolderWorkflowTypeConstant from '@/constants/folderWorkflowTypeConstant'
import RepairFileGuaranteeConstant from '@/constants/repairFileGuaranteeConstant'
import LeaveModal from '@/components/modal/repair-file/LeaveModal.vue'
import LeaveStepperModal from '@/components/modal/repair-file/LeaveStepperModal.vue'
import { auth as $store } from '@/store/AuthModule'
import FolderTypeConstant from '@/constants/repairModule/FolderTypeConstant'
import StepperRepair from '@/views/restricted/repair-file-module/folder-setup/stepper/StepperRepair.vue'
import StepperProspect from '@/views/restricted/repair-file-module/folder-setup/stepper/StepperProspect.vue'
import { checkPermission, displayToast } from '@/components/utils/globalFunction'
import router from '@/router'

export default {
  name: 'StepperFilePage',
  components: {
    StepperProspect,
    StepperRepair,
    StepCreateProspectFolder,
    LeaveStepperModal,
    LeaveModal,
    StepProduct,
    StepBreakdown,
    StepGenericBreakdown,
    StepGuarantee,
    StepPricing,
    StepGenericPricing,
    StepCreateRepairFolder,
    StepStoreInternalInformation,
    StepTransporter
  },
  props: {
    repairFileBoomerangId: String
  },
  async beforeRouteLeave(to, from, next) {
    if (this.currentRepairFile) {
      const path_split = to.path.split('/')

      // Navigate to finalization/shipping
      if (
        path_split.length > 3 &&
        (path_split[2] === 'finalization' || path_split[2] === 'shipping')
      ) {
        next()
        return
      }

      // Skip to prevent infinite loop
      if (to.query.skip !== null && to.query.skip === 'true') {
        next()
        return
      }

      // Initial state to leave
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.PRODUCT_SELECTED ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED
      ) {
        const confirm = await this.$refs.leaveModal.show()
        if (confirm) {
          const data = {
            repair_file_id: this.currentRepairFile.technical_id,
            requestor_collaborator_id: this.getCurrentCollaborator().technical_id
          }
          await RepairFileService.close(data)
          next()
        } else {
          next(false)
        }
        return
      }

      // Advanced state with leave or recycle option
      if (this.shouldShowLeaveStepperModal()) {
        const promiseResponse = await this.$refs.leaveStepperModal.show({
          currentRepairFile: this.currentRepairFile
        })

        if (promiseResponse === 'saveAndLeave') {
          await this.updateRepairFile()
          next()
        } else if (promiseResponse === 'saveAndLeaveWithReason') {
          next()
        } else if (promiseResponse === 'saveAndLeaveWithReasonAndRecycle') {
          // If we click on recycler button, we change redirect to recycling module.
          // Use skip query param for by pass next beforeRouteLeave cycle.
          if (checkPermission(['DISTRIBUTOR_RECYCLING_READ'])) {
            next({
              name: 'RecyclingCreateFolderPage',
              query: { skip: 'true', repairFileBoomerangId: this.currentRepairFile.boomerang_id }
            })
          } else {
            next({
              name: 'Dashboard',
              query: { skip: 'true' }
            })
          }
        } else {
          next()
        }
      } else {
        next()
      }
    } else {
      next()
    }
  },
  data() {
    return {
      currentStep: 0,
      highestStepReached: 0,
      currentRepairFile: null,
      status_detail: null,
      step: null,
      getLoadingData: true,
      recapSteps: []
    }
  },
  computed: {
    FolderTypeConstant() {
      return FolderTypeConstant
    },
    FolderWorkflowTypeConstant() {
      return FolderWorkflowTypeConstant
    },
    formattedTypeList: function () {
      const typeArray = this.currentRepairFile.product_guarantee_list.map((element) =>
        this.$t('COMMON.PRODUCT_TYPE.' + element.product_type)
      )
      return typeArray.join(', ')
    }
  },
  watch: {
    async repairFileBoomerangId() {
      this.currentRepairFile = await RepairFileService.get(this.repairFileBoomerangId)
      await this.getActualPosition()
    },
    async currentStep() {
      this.getLoadingData = false
      if (this.repairFileBoomerangId) {
        this.currentRepairFile = await RepairFileService.get(this.repairFileBoomerangId)
        const storeList = this.$store.getters['auth/getStoreListCollaborator']
        const storeFound = storeList.find(
          (store) => store.name === this.currentRepairFile.store_name
        )
        this.$store.commit('auth/setRepairFileStoreSelected', storeFound)
      }
      this.getLoadingData = true
      this.addRecapSteps()
      if (
        this.currentRepairFile &&
        this.currentRepairFile.step !== this.step &&
        this.currentRepairFile.status_detail !== this.status_detail
      ) {
        await this.getActualPosition()
        this.step = this.getActualPosition.step
        this.status_detail = this.currentRepairFile.status_detail
      }
    }
  },
  async created() {
    if (this.$route.params.repairFileBoomerangId.length !== 0) {
      try {
        this.currentRepairFile = await RepairFileService.get(this.repairFileBoomerangId)
        if (
          this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER
        ) {
          this.$router.push('/repair-file/shipping/' + this.$route.params.repairFileBoomerangId)
        } else if (
          this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.FINALIZE_REPAIR_FILE
        ) {
          this.$router.push('/repair-file/finalization/' + this.$route.params.repairFileBoomerangId)
        } else {
          await this.getActualPosition()
        }
      } catch (error) {
        this.leave()
      }
    } else {
      this.currentStep = 1
    }
    this.$store.commit('auth/setRepairFileStoreSelected', null)
  },
  methods: {
    leave() {
      this.$router.push({ name: 'Dashboard' })
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    async getActualPosition() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.PRODUCT_SELECTED:
          await this.handleStepChange(2)
          this.handleHighestStepChange(2)
          break

        case RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED:
          await this.handleStepChange(3)
          this.handleHighestStepChange(3)
          break

        case RepairFileStatusDetailConstant.GUARANTEE_EVALUATED:
        case RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER:
          await this.handleStepChange(4)
          this.handleHighestStepChange(4)
          break

        case RepairFileStatusDetailConstant.PRICING_EVALUATED:
          if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
            await this.handleStepChange(5)
            this.handleHighestStepChange(5)
          } else {
            await this.handleStepChange(5)
            this.handleHighestStepChange(5)
          }
          break

        case RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED:
          if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
            await this.handleStepChange(6)
            this.handleHighestStepChange(6)
          } else {
            await this.handleStepChange(7)
            this.handleHighestStepChange(7)
          }
          break

        case RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED:
        case RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT:
        case RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE:
          await this.handleStepChange(6)
          this.handleHighestStepChange(6)
          break

        case RepairFileStatusDetailConstant.INFORMATION_RETRIEVED:
        case RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED:
          if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
            await this.handleStepChange(7)
            this.handleHighestStepChange(7)
          } else {
            await this.handleStepChange(6)
            this.handleHighestStepChange(6)
          }
          break

        default:
          await this.$router.push({ name: 'Dashboard' })
          break
      }
    },
    async handleStepChange(changeStep) {
      if (changeStep !== this.currentStep) {
        if (this.currentRepairFile) {
          if (
            this.currentRepairFile.status_detail !==
              RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED &&
            this.currentStep === 2 &&
            changeStep < this.currentStep
          ) {
            if (
              this.currentRepairFile.product_folder_workflow === FolderWorkflowTypeConstant.GENERIC
            ) {
              await this.$refs.stepBreakdown.updatePartialData()
            } else {
              await this.$refs.stepBreakdown.updatePartialData()
            }
          }
          if (
            this.currentRepairFile.status_detail ===
              RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED &&
            this.currentStep === 3 &&
            changeStep < this.currentStep
          ) {
            await this.$refs.stepGuarantee.updatePartialData()
          }
          if (
            this.currentStep === 4 &&
            (this.currentRepairFile.status_detail ===
              RepairFileStatusDetailConstant.GUARANTEE_EVALUATED ||
              this.currentRepairFile.status_detail ===
                RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER) &&
            changeStep < this.currentStep
          ) {
            if (
              this.currentRepairFile.product_folder_workflow !== FolderWorkflowTypeConstant.GENERIC
            ) {
              await this.$refs.stepPricing.updatePartialData()
            }
          }
          if (
            this.currentRepairFile.status_detail ===
              RepairFileStatusDetailConstant.PRICING_EVALUATED &&
            this.currentStep === 5 &&
            changeStep < this.currentStep
          ) {
            if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
              await this.$refs.stepStoreInternalInformation.updatePartialData()
            } else {
              await this.$refs.stepCreateRepairFolder.updatePartialData()
            }
          }
          if (
            (this.currentRepairFile.status_detail ===
              RepairFileStatusDetailConstant.INFORMATION_RETRIEVED ||
              this.currentRepairFile.status_detail ===
                RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE) &&
            this.currentStep === 6 &&
            changeStep < this.currentStep
          ) {
            if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
              await this.$refs.stepCreateProspectFolder.updatePartialData()
            } else {
              await this.$refs.stepStoreInternalInformation.updatePartialData()
            }
          }
          if (
            this.currentRepairFile.status_detail ===
              RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED &&
            this.currentStep === 7 &&
            changeStep < this.currentStep
          ) {
            await this.$refs.stepTransporterFolder.updatePartialData()
          }
        }
        this.currentStep = changeStep
      }
    },
    async handleRefreshRepairFile() {
      this.currentRepairFile = await RepairFileService.get(this.repairFileBoomerangId)
    },
    handleHighestStepChange(changeHighestStep) {
      this.highestStepReached = changeHighestStep
      if (this.recapSteps.includes(changeHighestStep)) {
        let indexToRemove = this.recapSteps.indexOf(changeHighestStep)
        this.recapSteps = this.recapSteps.slice(0, indexToRemove)
      }
    },
    addRecapSteps() {
      for (let step = 1; step < this.currentStep; step++) {
        if (!this.recapSteps.includes(step)) {
          this.recapSteps.push(step)
        }
      }
    },
    isInGuarantee() {
      return this.currentRepairFile.status_guarantee !== RepairFileGuaranteeConstant.NOT_GUARANTEE
    },
    async updateRepairFile() {
      if (this.currentRepairFile) {
        if (
          this.currentStep === 4 &&
          this.currentRepairFile.product_folder_workflow !== FolderWorkflowTypeConstant.GENERIC
        ) {
          await this.$refs.stepPricing.updatePartialData()
        } else if (this.currentStep === 5) {
          if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
            await this.$refs.stepStoreInternalInformation.updatePartialData()
          } else {
            await this.$refs.stepCreateRepairFolder.updatePartialData()
          }
        } else if (this.currentStep === 6) {
          if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
            await this.$refs.stepCreateProspectFolder.updatePartialData()
          } else {
            await this.$refs.stepStoreInternalInformation.updatePartialData()
          }
        } else if (this.currentStep === 7) {
          await this.$refs.stepTransporterFolder.updatePartialData()
        } else {
          displayToast(this.$t('ERROR.UNEXPECTED_ERROR_KEY'), 'error')
        }
      }
    },
    shouldShowLeaveStepperModal() {
      const statusDetails = [
        RepairFileStatusDetailConstant.GUARANTEE_EVALUATED,
        RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER,
        RepairFileStatusDetailConstant.PRICING_EVALUATED,
        RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED,
        RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT,
        RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE,
        RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED,
        RepairFileStatusDetailConstant.INFORMATION_RETRIEVED,
        RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED
      ]

      return statusDetails.includes(this.currentRepairFile.status_detail)
    }
  }
}
</script>

<style scoped>
.v-container {
  padding: 18px;
}

.info-col {
  background-color: #165039 !important;
  color: white !important;
  overflow: hidden;
}

.line {
  height: 4px;
  margin-left: 49%;
  margin-right: 49%;
  background: white;
}

.v-card {
  padding: 20px;
}

.title {
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.sub-title {
  color: #acacac;
  font-size: 13px;
  font-style: normal;
  line-height: 20px;
}

.content-card {
  color: #acacac;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: right;
}

.content-text {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.cross-white-svg {
  margin-top: 1px;
  margin-right: 5px;
  height: 100%;
  width: 50%;
}

.leave-button {
  width: 100%;
  height: 60px;
  padding: 22px 40px 22px 40px;
  border-radius: 20px;
  border: 1px solid #ffffff;
  gap: 15px;
  text-transform: unset !important;
}

.custom-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: stretch;
  height: 100%;
  justify-content: space-between;
}

.repair-file-number {
  font-weight: bold;
}

.white-icon {
  height: 100%;
  width: 20%;
  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%);
}

.step-one-scroll-indicator {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin-top: 70vh;
}
</style>
